hrd.utils.NumberConverter = hrd.Class.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.utils.NumberConverter',
			locale: 'it',
			localeSpecs: {
				decimalSeparator: ',',
				groupingSeparator: '.'
			}
		};
		this._super($.extend(true, {}, defaults, options));
		this.build();
	},
	build: function() {
		let locale = this.settings.locale;
		this.numberFormat = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		const numerals = (new Intl.NumberFormat(locale, { useGrouping: false }).format(9876543210)).split('').reverse();
		const index = new Map(numerals.map((d, i) => [d, i]));
		this._group = this.settings.localeSpecs.groupingSeparator;
		this._decimal = this.settings.localeSpecs.decimalSeparator;
		this._numeral = new RegExp(`[${numerals.join("")}]`, "g");
		this._index = d => index.get(d);
	},
	convert: function(string) {
		return (string = string.trim()
			.replaceAll(this._group, "")
			.replace(this._decimal, ".")
			.replace(this._numeral, this._index)) ? +string : NaN;
	},
	format: function(number) {
		return this.numberFormat.format(number);
	}
});
